import { useEffect, useState } from 'react'

import { quantApi } from '@/app/lib/quant/quantApi'
import type { QuantConfig } from '@/app/lib/quant/types'

/** The Quant config (`max_concurrent_runs`, `jupyter_url`); `null` until loaded or if the read fails. */
export function useQuantConfig(): QuantConfig | null {
  const [config, setConfig] = useState<QuantConfig | null>(null)

  useEffect(() => {
    let cancelled = false
    quantApi
      .getConfig()
      .then((result) => {
        if (!cancelled) setConfig(result)
      })
      .catch(() => {
        /* The kicker simply omits the slot count. */
      })
    return () => {
      cancelled = true
    }
  }, [])

  return config
}
